import { AnalyzerFileDefinition } from "../responses/analyzeCSVResponse";

export class GenerateTransformationRequest {
    public sourceFileDefinition? : AnalyzerFileDefinition;
    public targetFileDefinition? :AnalyzerFileDefinition; //either this or targetFileContent needs to be set for generation to work

    public targetFileContent?: string; //base64 encoded target file content
    public targetFileName?: string; //name of the target file

    public sourceSampleData?: string; //unused for now
    public targetSampleData?: string; //unused for now and potentially redundent to targetFileContent

    public includeDescription: boolean = false;
    public strictValidation: boolean = false;

    public context?: string; //contains information for the server to decide if specific specialized prompts have to be used like 'isolved|60' or 'ukg|60'. current format: 'partner|integration type id'

    public requestorId!: number; //id of the user making the request
}